import { Injector } from '@angular/core';
import { AbcCore, CompareHelper } from '@barthauer/abc/core';
import { ObjectTypeInfoViewModel } from '@barthauer/abc/core/data';

export class ObjectsSetsColumnInfo {
  private core: AbcCore;
  private objectTypeInfoViewModel: ObjectTypeInfoViewModel;
  private _idExpression: string;
  private _objectTypeExpr: string;

  public get idExpression(): string {
    if (!this._idExpression) {
      this.getIdAndOtExpressions();
    }
    return this._idExpression;
  }
  public get objectTypeExpression(): string {
    if (!this._objectTypeExpr) {
      this.getIdAndOtExpressions();
    }
    return this._objectTypeExpr;
  }

  constructor(private objectType: string, private injector: Injector) {
    this.core = this.injector.get(AbcCore);
    Promise.resolve(this.getObjectTypeInfoVM());
  }

  private async getObjectTypeInfoVM(): Promise<ObjectTypeInfoViewModel> {
    this.objectTypeInfoViewModel = await this.core.objectSpace.getObjectType(this.objectType).toPromise();
    return this.objectTypeInfoViewModel;
  }

  private getIdAndOtExpressions(): void {
    const oric = this.objectTypeInfoViewModel.objectReferenceInfoColumns;

    if (!CompareHelper.isEmptyObject(oric)) {
      const id = oric.id.name;
      const ot = oric.objectType.name;

      this._idExpression =
        this.objectTypeInfoViewModel.columnsByNameInBaseType.get(id)?.name ||
        this.objectTypeInfoViewModel.columnsByName.get(id)?.name ||
        this._idExpression;
      this._objectTypeExpr =
        this.objectTypeInfoViewModel.columnsByNameInBaseType.get(ot)?.name ||
        this.objectTypeInfoViewModel.columnsByName.get(ot)?.name ||
        this._objectTypeExpr;
    } else {
      this._idExpression = 'Id';
      this._objectTypeExpr = 'ObjectType';
    }
  }
}

export class ObjectsSetsSettings {
  public static getCurrentContainerId: () => Promise<string>;
  public static orderUnits?: OrderUnit[];
}

export class OrderUnit {
  name: string;
  caption: string;
  referencedObjectTypeName: string;
  referencedObjectTypeValue?: number;
  isPreSelected?: boolean;
  data: () => Promise<{ Designation: string; Id: string }[]>;
}
